import {Alert, Button, Container, Divider, Grid, Link, Stack, TextField, Typography} from "@mui/material";
import React, {useState} from "react";
import {useNavigate} from "react-router";
import {useSiteDataContext} from "../Contexts/SiteDataContext";

function IndexPage() {
    const navigate = useNavigate();
    const text = useSiteDataContext();
    const page = text.pages.index;
    if(text?.siteData?.notPublic) {
        return <div style={{width:'100vw',height:'100vh',alignItems:'center',justifyContent:'center',position:'fixed',display:'flex','top':0}}>
            <Container maxWidth="xs">
            <Alert severity="error">
                This site does not support the public interface.
            </Alert>
            </Container>
        </div>
    }
    return (<Container maxWidth="md">
        <Grid container spacing={4}>
            <Grid item xs={12} md={6}>
                <Typography typography="h1" color="primary">{text?.siteData?.name??''}</Typography>
                <Typography typography="subtitle" color="primary">{page.subtitle}</Typography>
                <Divider sx={
                    (theme)=>({
                        paddingTop:theme.spacing(4)
                    })}
                />
            </Grid>
            <Grid item xs={12} md={6}>
                <Button color="secondary" fullWidth={true} onClick={()=>navigate('/login')} sx={(theme)=>({marginBottom:theme.spacing(4)})} variant="contained" size="large">{page.manageSubscriptionButton}</Button>
                <Button color="secondary" fullWidth={true} onClick={()=>navigate('/purchase-subscription')} sx={(theme)=>({marginBottom:theme.spacing(4)})} variant="contained" size="large">{page.purchaseSubscriptionButton}</Button>
            </Grid>
        </Grid>
    </Container>);
}
export default IndexPage;